export enum ReportStatus {
  Completed = 'Completed',
  CompletedWithRevisions = 'Completed With Revisions',
  MissingInformation = 'Missing Information',
  Processing = 'Processing',
  Enqueued = 'Enqueued',
  Error = 'Error',
}

export interface ReportItem {
  status: ReportStatus;
  [key: string]: any; // Allow other properties
}
